import moment from "moment-timezone"
import "moment/locale/fr"

const formatHour = (dateStart, dateEnd, start, end) => {
  if (start !== null && end === null) {
    return "à " + start
  } else if (start !== null && end !== null) {
    return "de " + start + " à " + end
  }
  return ""
}

const formatType = (isOnline) => isOnline ? " - En distanciel" : " - En présentiel"

const formatDate = (start, end, horaires) => {
  const formatDay = (date) => moment(date).date() === 1 ? "1er" : moment(date).format("D")
  const monthStart = moment(start).format("MMMM") !== moment(end).format("MMMM") ? moment(start).format("MMMM") : ""
  if (start !== end) {
    return " du " + moment(start).format("dddd") + " " + formatDay(start) + " " + monthStart + " au " + moment(end).format("dddd D MMMM YYYY") + " " + horaires
  } else {
    return " le " + moment(start).format("dddd") + " " + formatDay(start) + " " + moment(start).format("MMMM YYYY") + " " + horaires
  }
}

export const formatEvent = (events, contact = true) => {
  let campaigns = events.map(event => {
    const label = event.Label__c || ""
    const startDate = event.StartDate
    const endDate = event.EndDate
    const startTime = event.EventStartHour__c
    const endTime = event.EventEndHour__c
    const horaires = formatHour(startDate, endDate, startTime, endTime)
    const type = formatType(event.IsOnline__c)
    const dateDuration = formatDate(startDate, endDate, horaires)

    return {
      label: label + dateDuration + type,
      value: event.Id,
      date: moment(event.StartDate).format("dddd D MMMM YYYY"),
      dateDuration: dateDuration,
    }
  })

  if (contact) {
    campaigns.push({
      label: "Je ne suis pas disponible à ces dates",
      value: "unavailable",
    })
  }

  return campaigns
}
